<template>
  <div class="form-list fh">
    <div class="form-list-bar">
      <div class="v-center space-between">
        <div class="form-list-bar-title v-center">
          <label class="elipsis-text xxxl">
            Job Orders
          </label>
        </div>
      </div>
      <div class="space-between v-center">
        <div class="flex-start mt-3">
          <button class="btn btn-2 mr-2">Export CSV</button>
        </div>
        <div class="flex-end mt-3">
          <div>
            <label for="">Sort By</label>
            <select class="sort">
              <option value="1">Latest</option>
              <option value="2">Oldest</option>
            </select>
          </div>
          <button class="btn addfilter v-center ml-2">
            <img
              src="~@/assets/images/icons/filter-icon.svg"
              alt=""
              width="14"
              class="mr-1"
            /> Add Filter
          </button>
          <button class="btn ml-2 pointer" @click="goToCreateForm">
            Create Form
          </button>
        </div>
      </div>
    </div>

    <div class="dashboard-container">
      <div class="total">
        <img width="20px" src="~@/assets/images/form-icon.png" alt="" />
        <label style="margin-top: 5px;">Total Forms</label>
        <label style="font-weight: 700; font-size: var(--text-3xl);">{{ dummyData.length }}</label>
      </div>
      <div class="status-card" v-for="(status, index) in statuses" :key="index">
        <img :src="status.image" alt="status-icon" class="status-image" />
        <div class="status-value" style="display: flex; flex-direction: column; align-items: center;">
          <span style="font-weight: 400; font-size: var(--text-s); margin-top: 4px;">{{ status.label }}</span>
          <span style="font-weight: 700; font-size: var(--text-xl);">{{ status.value }}</span>
        </div>
      </div>
    </div>

    <div class="form-list-container">
      <div class="copy-dtx-table form-table">
        <table>
          <thead>
            <tr>
              <th>S.No</th>
              <th>Job Name</th>
              <th>Description</th>
              <th>Status</th>
              <th>Due Date</th>
              <th>Created</th>
              <th>Updated</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in dummyData" :key="row.id">
              <td>{{ index + 1 }}</td>
              <td><span class="cell-ellipsis">{{ row.name }}</span></td>
              <td><span class="cell-ellipsis">{{ row.description }}</span></td>
              <td>
                <div class="status-display">
                  <img :src="getStatusImage(row.statusId)" alt="status-icon" class="status-icon" />
                  {{ row.status }}
                </div>
              </td>
              <td>{{ row.dueDate }}</td>
              <td class="audit-cell">
                <span class="audit-name">{{ row.createdBy }}</span>
                <span class="audit-date">{{ row.createdOn }}</span>
              </td>
              <td class="audit-cell">
                <span class="audit-name">{{ row.updatedBy }}</span>
                <span class="audit-date">{{ row.updatedOn }}</span>
              </td>
              <td class="action-column">
                <div class="action-icons">
                    <img class="edit ml-2" v-if="row.statusId === 4" src="~@/assets/images/icons/undo-icon.svg" title="Reopen Form" />
                    <img src="~@/assets/images/trash-2.svg" class="delete pointer" width="16" alt="Delete" title="Delete form"/>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JobOrderList',
  data () {
    return {
      statuses: [
        {
          id: 1,
          label: 'Open Forms',
          value: 2,
          image: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%235ba3e5' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect width='18' height='11' x='3' y='11' rx='2' ry='2'/%3E%3Cpath d='M7 11V7a5 5 0 0 1 9.9-1'/%3E%3C/svg%3E"
        },
        {
          id: 2,
          label: 'Draft Forms',
          value: 1,
          image: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%239d56bd' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M12 2a10 10 0 0 1 7.38 16.75'/%3E%3Cpath d='M12 6v6l4 2'/%3E%3Cpath d='M2.5 8.875a10 10 0 0 0-.5 3'/%3E%3Cpath d='M2.83 16a10 10 0 0 0 2.43 3.4'/%3E%3Cpath d='M4.636 5.235a10 10 0 0 1 .891-.857'/%3E%3Cpath d='M8.644 21.42a10 10 0 0 0 7.631-.38'/%3E%3C/svg%3E"
        },
        {
          id: 3,
          label: 'Reopen Forms',
          value: 1,
          image: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23d9b568' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m12 15 2 2 4-4'/%3E%3Crect width='14' height='14' x='8' y='8' rx='2' ry='2'/%3E%3Cpath d='M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2'/%3E%3C/svg%3E"
        },
        {
          id: 4,
          label: 'Closed Forms',
          value: 1,
          image: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='28' height='28' viewBox='0 0 24 24' fill='none' stroke='%2343d68a' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='12' cy='12' r='10'/%3E%3Cpath d='m9 12 2 2 4-4'/%3E%3C/svg%3E"
        }
      ],
      dummyData: [
        {
          id: 1,
          name: 'Job Order #1001',
          description: 'HVAC Maintenance on Floor 3',
          statusId: 1,
          status: 'OPEN',
          dueDate: '15 Nov 2023',
          createdBy: 'John Doe',
          createdOn: '01 Nov 2023',
          updatedBy: 'Jane Smith',
          updatedOn: '10 Nov 2023'
        },
        {
          id: 2,
          name: 'Job Order #1002',
          description: 'Server Rack Assembly',
          statusId: 2,
          status: 'DRAFT',
          dueDate: '20 Nov 2023',
          createdBy: 'Alice Wong',
          createdOn: '05 Nov 2023',
          updatedBy: 'Alice Wong',
          updatedOn: '06 Nov 2023'
        },
        {
          id: 3,
          name: 'Job Order #1003',
          description: 'Quarterly Safety Audit',
          statusId: 3,
          status: 'REOPENED',
          dueDate: '01 Dec 2023',
          createdBy: 'Bob Builder',
          createdOn: '15 Sep 2023',
          updatedBy: 'John Doe',
          updatedOn: '12 Oct 2023'
        },
        {
          id: 4,
          name: 'Job Order #1004',
          description: 'Network Switch Upgrade',
          statusId: 4,
          status: 'CLOSED',
          dueDate: '25 Oct 2023',
          createdBy: 'Charlie Day',
          createdOn: '20 Aug 2023',
          updatedBy: 'Eve Adams',
          updatedOn: '26 Oct 2023'
        },
        {
          id: 5,
          name: 'Job Order #1005',
          description: 'Replace Lighting Fixtures',
          statusId: 1,
          status: 'OPEN',
          dueDate: '10 Dec 2023',
          createdBy: 'Frank Castle',
          createdOn: '02 Nov 2023',
          updatedBy: 'Frank Castle',
          updatedOn: '05 Nov 2023'
        }
      ]
    }
  },
  created () {
    if (this.$route.query?.created === '1') {
      this.$notify.success('Job order created and executed successfully!')
      const query = { ...this.$route.query }
      delete query.created
      this.$router.replace({ path: this.$route.path, query })
    }
  },
  methods: {
    goToCreateForm () {
      this.$router.push('/job-orders/create')
    },
    getStatusImage (statusId) {
      const match = this.statuses.find(s => s.id === statusId)
      return match ? match.image : ''
    }
  }
}
</script>

<style scoped lang="scss">
.form-list {
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  min-width: 0;
  overflow: hidden;

  &-bar {
    flex-shrink: 0;
    .sort {
      height: 2em; width: 10rem; margin: 2px 10px 0 10px;
      font-size: var(--text-base); background-color: var(--brand-light-color);
      line-height: 1; border: 1px solid var(--brand-color); border-radius: 4px; padding: 4px 12px;
    }
    &-title { font-size: var(--text-l); font-weight: 500; }
  }

  &-container {
    margin: 10px 0;
    flex: 1;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    table {
      width: 100%;
      table-layout: fixed;

      th, td {
        width: auto;
        max-width: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        border-bottom: 1px solid #e5e7eb;
      }
    }
  }
}

.btn-2 { width: fit-content; height: fit-content; padding: 6px; }

.dashboard-container {
  flex-shrink: 0;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding: 10px 0;
}

.total, .status-card {
  height: 120px;
  flex: 1 1 calc((100% - 48px) / 5);
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.copy-dtx-table.form-table {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: auto !important;
  max-height: calc(100vh - 370px);
  border-radius: 10px;

  table {
    width: 100%;
    max-width: 100%;
    max-height: 100%;
  }
}

.cell-ellipsis {
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.status-display { display: flex; align-items: center; gap: 4px; }
.status-icon { width: 15px; height: 15px; }

.audit-cell {
  white-space: normal !important;
  line-height: 1.2;
}
.audit-name,
.audit-date {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.audit-name {
  font-size: var(--text-xs2);
  font-weight: 400;
  color: #111827;
}
.audit-date {
  margin-top: 4px;
  font-size: var(--text-xs);
  color: #6b7280;
}
</style>
